var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"sber-btn",attrs:{"block":"","large":""},on:{"click":_vm.loginWithSberId}},[_vm._v("Войти со Сбер ID")])}
var staticRenderFns = []

export { render, staticRenderFns }